// extracted by mini-css-extract-plugin
export default {"background":"cR","weightImage":"eR","drinkImage":"fR","content":"gR","rtbLeft":"hR","rtbRight":"iR","rtbLeftMobile":"jR","imageContainer":"kR","rtbBox":"lR","line":"mR","rtbDesktop":"nR"};
    if(module.hot) {
      // 1730991509053
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  